import { Component, Input, OnChanges } from '@angular/core';
import { ErreurInput } from '../../models/erreurs/erreur-input';
import { ErreurMappingService } from '../../services/errors/erreur-mapping.service';

@Component({
  selector: 'app-erreur-input',
  templateUrl: './erreur-input.component.html',
  standalone: false,
})
export class ErreurInputComponent implements OnChanges {
  @Input() erreurInput: ErreurInput;

  currentError: string;

  constructor(private readonly erreurMappingCanadaForm: ErreurMappingService) {}

  ngOnChanges() {
    if (!this.erreurInput.hasError) return;
    this.currentError = this.erreurMappingCanadaForm.getErrorTextFromMappingErreurInput(this.erreurInput);
  }
}
